<!--
 * @Description:不可编辑分享页
 * @Author: ll
 * @Date: 2021-9-13 11:38:30
 * @LastEditTime: 
 * @LastEditors: ll
-->
<template>
  <div class="cr-cannotShare cr-fs-md">
    <cr-loading :loading="loading"></cr-loading>
    <div class="cr-imgs"></div>
    <div class="cr-cont">
      <div class="cr-header">
        <div class="cr-desc1 cr-jc-between cr-text-black-1 cr-mb-1">
          <span>{{ getChildState(overviewData.childState) }}</span>
          <div>
            <a class="cr-fs-md" v-for="(attach, index) in attachs" :key="index" :href="attach.attachmentUrl">《{{ attach.attachmentName }}》</a>
          </div>
        </div>
        <div class="cr-desc2 cr-text-black-1 cr-mb-3">案件号：{{ caseNo }}</div>
        <div class="cr-desc3 cr-jc-between cr-mb-3" v-show="overviewData.childState == 31">
          <div class="cr-text-black-1 cr-ai-center">
            <div class="cr-desc4 cr-mr-1 cr-text-red"><a-icon type="exclamation-circle" /></div>
            {{ getChildState(overviewData.childState) }}{{ optLogInfos.remark }}
          </div>
          <span class="cr-text-grey-1">{{ optLogInfos.date }}</span>
        </div>
      </div>
      <detail-cont v-if="caseNo" :caseNo="caseNo" />
      <div class="cr-footer cr-pr-2 cr-jc-end cr-ai-center" v-show="overviewData.childState == 32 || overviewData.childState == 35">
        <a-button type="primary" v-show="overviewData.childState == 32" @click="checkVisible = true">确认核对表</a-button>
        <a-button type="primary" v-show="overviewData.childState == 35" @click="downMaterials">下载邮寄说明</a-button>
      </div>
      <!-- 确认核对表 -->
      <check-list :checkVisible.sync="checkVisible" v-if="caseNo && overviewData.childState == 32" :caseNo="caseNo" />
    </div>
  </div>
</template>

<script>
import checkList from './component/checklist.vue'
import { overview, attachments } from '@/api/cannotEdit.js'
import DetailCont from './component/detailCont.vue'
export default {
  data() {
    return {
      caseNo: '',
      optLogInfos: {},
      checkVisible: false,
      overviewData: {},
      loading: false,
      attachs: []
    }
  },
  components: {
    DetailCont,
    checkList
  },
  mounted() {
    this.caseNo = this.$route.query.caseNo
    this.init(this.caseNo)
  },
  methods: {
    async init(caseNo) {
      this.loading = true
      const res = await overview(caseNo)
      const res1 = await attachments(this.caseNo)
      this.attachs = res1.data[0].attachments
      this.overviewData = res.data
      this.loading = false
      this.optLogInfos = res.data.optLogInfos[0]
    },
    // 判断案件状态
    getChildState(state) {
      switch (state) {
        case 10:
          return '待付款'
        case 20:
          return '待补充信息'
        case 30:
          return '待平台审核'
        case 31:
          return '平台审核未通过'
        case 32:
          return '待客户确认表'
        case 33:
          return '确认表有误'
        case 34:
          return '业务待处理'
        case 35:
          return '材料待邮寄'
        case -30:
          return '待退款'
        case 40:
          return '已递交官方'
        case 41:
          return '下发补正通知书'
        case 42:
          return '已下证'
        case 43:
          return '已完成'
        case -40:
          return '已退款'
        default:
          break
      }
    },
    // 下载邮寄材料
    async downMaterials() {
      let data = {
        caseNo: this.caseNo,
        fullName: this.overviewData.fullName
      }
      console.log(data)
      const res = await downloadMaterials(data)
      console.log(res)
    }
  }
}
</script>

<style lang="less" scoped>
.cr-cannotShare {
  overflow-x: hidden;
  .cr-imgs {
    height: 572px;
    background: url('../../../../static/images/shareDetail.png') no-repeat;
    background-position: center;
    background-size: cover;
  }
  .cr-cont {
    width: 1200px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.97);
    z-index: 99;
    padding: 30px 40px;
    margin-top: -300px;
    border: 1px solid #eaeaea;
    .cr-header {
      .cr-desc1 {
        font-size: 24px;
        font-weight: bolder;
      }
      .cr-desc2 {
        font-weight: 600;
      }
      .cr-desc3 {
        width: 1120px;
        height: 40px;
        line-height: 40px;
        background: #fff1f0;
        border-radius: 4px;
        border: 1px solid #ffa39e;
        padding: 0 15px;
        .cr-desc4 {
        }
      }
    }
    .cr-footer {
      border-top: 1px solid #f0f0f0;
      width: 100%;
      height: 60px;
      background: #fff;
      position: fixed;
      bottom: 0;
      left: 0;
      .ant-btn {
        margin-right: 10px;
      }
    }
  }
}
</style>
